import React, { useState } from "react";
import { Form, Input } from "antd";
import { yesNoOptions } from "../../../../Options/commonOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";

const SurgicalIncision = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  return (
    <>
      <DeselectableRadioGroup
        label={"Surgical Incision"}
        name={"surgical_incision"}
        options={yesNoOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue("surgical_incision") === "yes" && (
        <Form.Item name="surgical_incision_description">
          <Input.TextArea
            rows={3}
            type="text"
            placeholder="Description"
            style={{ width: "100%" }}
          />
        </Form.Item>
      )}
    </>
  );
};

export default SurgicalIncision;
